import { CoverageOverviewReport } from "./applications/analytics/executive/CoverageOverview/CoverageOverviewReport";
import { CoverageReport } from "./applications/analytics/executive/Coverage/CoverageReport";
import { AttendanceReport } from "./applications/analytics/executive/Attendance/AttendanceReport";
// Region dashboard when the user login is Executive
import { ExecutiveRegionComparativeSalesPerf } from "./applications/analytics/executiveregion/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { ExecutiveRegionPerformanceByProductGroup } from "./applications/analytics/executiveregion/PerformanceByProductGroup/PerformanceByProductGroup";
import { ExecutiveRegionComparativeSales } from "./applications/analytics/executiveregion/ComparativeSales/ComparativeSales";
import { ExecutiveRegionGrowthPerformance } from "./applications/analytics/executiveregion/GrowthPerformance/GrowthPerformance";
import { ExecutiveRegionCustomerSales } from "./applications/analytics/executiveregion/CustomerSales/CustomerSales";
import { ExecutiveRegionalCustomerGroupProduct } from "./applications/analytics/executiveregion/CustomerGroupProduct/CustomerGroupProduct";

import { AgentComparativeSalesPerf } from "./applications/analytics/agent/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { AgentPerformanceByProductGroup } from "./applications/analytics/agent/PerformanceByProductGroup/PerformanceByProductGroup";
import { AgentComparativeSales } from "./applications/analytics/agent/ComparativeSales/ComparativeSales";
import { AgentGrowthPerformance } from "./applications/analytics/agent/GrowthPerformance/GrowthPerformance";
import { AgentCustomerSales } from "./applications/analytics/agent/CustomerSales/CustomerSales";
import { AgentCustomerGroupProduct } from "./applications/analytics/agent/CustomerGroupProduct/CustomerGroupProduct";

import { DistributorComparativeSalesPerf } from "./applications/analytics/distributor/ComparativeSalesPerformance";

import { CustomerComparativeSalesPerf } from "./applications/analytics/customer/ComparativeSalesPerformance";

import { RegionAttendanceReport } from "./applications/analytics/region/Attendance/RegionAttendanceReport";

import { ItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { ProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { OPMIColorScheme } from "../themes/theme-opmi";

import {
  ApplicationBrand,
  MenuItems,
  ApplicationItems,
} from "../client-configuration";
import { DistrictAttendanceReport } from "./applications/analytics/district/Attendance/DistrictAttendanceReport";
import { RegionCoverageOverviewReport } from "./applications/analytics/region/CoverageOverview/RegionCoverageOverviewReport";
import { TradeTeamCoverageReport } from "./applications/analytics/ter/Coverage/CoverageReport";
import { RegionCoverageReport } from "./applications/analytics/region/Coverage/RegionCoverageReport";

const exportApplication = {
  applications: [
    {
      id: 1,
      name: "Comparative Sales Performance",
    },
    {
      id: 3,
      name: "Performance by Product Group",
    },
    {
      id: 4,
      name: "Comparative Sales",
    },
    {
      id: 7,
      name: "Customer Group Product",
    },
    {
      id: 5,
      name: "Growth Performance",
    },
    {
      id: 6,
      name: "Customer Sales",
    },
  ],
};

const exportApplicationCustomer = {
  applications: [
    {
      id: 1,
      name: "Comparative Sales Performance",
    },
  ],
};

const nullData = {};

// Modified by Argie: 08/20/2025

export const ExecutiveData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: CoverageOverviewReport,
  2: CoverageReport,
  3: AttendanceReport,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
};

export const DistrictData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: DistrictAttendanceReport,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
};

export const AgentData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: AgentComparativeSalesPerf,
  3: AgentPerformanceByProductGroup,
  4: AgentComparativeSales,
  5: AgentGrowthPerformance,
  6: AgentCustomerSales,
  7: AgentCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
};

export const ExecutiveRegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: ExecutiveRegionComparativeSalesPerf,
  3: ExecutiveRegionPerformanceByProductGroup,
  4: ExecutiveRegionComparativeSales,
  5: ExecutiveRegionGrowthPerformance,
  6: ExecutiveRegionCustomerSales,
  7: ExecutiveRegionalCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
};

export const RegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: RegionCoverageOverviewReport,
  2: RegionCoverageReport,
  3: RegionAttendanceReport,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
};

export const DistributorData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: DistributorComparativeSalesPerf,
  3: nullData,
  4: nullData,
  5: nullData,
  6: nullData,
  7: nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const CustomerData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: CustomerComparativeSalesPerf,
  3: nullData,
  4: nullData,
  5: nullData,
  6: nullData,
  7: nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const TradeTeamData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  2: TradeTeamCoverageReport,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const AgentProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: AgentItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const DistrictProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: DistrictItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const ProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: ItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const ProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: ProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const AgentProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: AgentProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const DistrictProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: DistrictProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
};

export const DefaultData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  1: nullData,
  3: nullData,
  4: nullData,
  5: nullData,
  6: nullData,
  7: nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  sections: [],
  palettes: [],
  themes: [],
};

function getDataByEndPoint(title) {
  return MenuItems[title] || null;
}

export { getDataByEndPoint };
